// Rank configuration
import { IdolRank } from '../types';

export interface RankData {
    id: IdolRank;
    label: string;
    fanReq: number;
    cashReq: number;
    color: string;
    multiplier: number;
    passiveIncome: number;
}

export const RANKS: Record<IdolRank, RankData> = {
    [IdolRank.TRAINEE]: { id: IdolRank.TRAINEE, label: 'TRAINEE', fanReq: 0, cashReq: 0, color: 'text-slate-500', multiplier: 1, passiveIncome: 10 },
    [IdolRank.ROOKIE]: { id: IdolRank.ROOKIE, label: 'ROOKIE', fanReq: 100000, cashReq: 500000, color: 'text-green-400', multiplier: 10, passiveIncome: 100 },
    [IdolRank.IDOL]: { id: IdolRank.IDOL, label: 'IDOL', fanReq: 1000000, cashReq: 2000000, color: 'text-blue-400', multiplier: 100, passiveIncome: 1000 },
    [IdolRank.SUPERSTAR]: { id: IdolRank.SUPERSTAR, label: 'SUPERSTAR', fanReq: 5000000, cashReq: 10000000, color: 'text-pink-400', multiplier: 1000, passiveIncome: 10000 },
    [IdolRank.LEGEND]: { id: IdolRank.LEGEND, label: 'LEGEND', fanReq: 20000000, cashReq: 50000000, color: 'text-yellow-400', multiplier: 10000, passiveIncome: 100000 },
};
